var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgView = function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#656565",
    strokeWidth: 1.5,
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#656565",
    strokeWidth: 1.5,
    d: "M14.535 7.112c.31.393.465.589.465.888s-.155.495-.465.888C13.402 10.325 10.902 13 8 13s-5.402-2.675-6.535-4.112C1.155 8.495 1 8.3 1 8s.155-.495.465-.888C2.598 5.675 5.098 3 8 3s5.402 2.675 6.535 4.112Z"
  })));
};
export default SvgView;